import axios from '@/lib/axios';
import { PurchaseOrderContractTaskSubscription } from '@/hooks/api/models';
import { useMutation } from '@tanstack/react-query';

/**
 * 0850. 発注案件契約タスク購読
 * [POST] /workspaces/:identifier/teams/:team_id/purchase_orders/:purchase_order_id/purchase_order_contract_tasks/:purchase_order_contract_task_id/purchase_order_contract_task_subscriptions
 */
type Props = {
  identifier: string;
  team_id: number;
  purchase_order_id: number;
  task_id: number;
};

const createPurchaseOrderContractTaskSubscription = (props: Props): Promise<PurchaseOrderContractTaskSubscription> => {
  return axios.post(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/purchase_orders/${props.purchase_order_id}/purchase_order_contract_tasks/${props.task_id}/purchase_order_contract_task_subscriptions`,
    props
  );
};

export const useCreatePurchaseOrderContractTaskSubscription = () => {
  return useMutation({
    mutationFn: createPurchaseOrderContractTaskSubscription,
  });
};
